import { Button, Form, Segmented } from 'antd';
import React, { useContext, useMemo, useState } from 'react';
import { MYCDate, MYCSearch, MYCSelect } from '../../components/input_form.component';
import { TripOrderCard } from '../../components/trip_order_card.component';
import { useGet, useGetPaginated } from '../../hooks/useRest.hook';
import { Endpoints } from '../../constants/endpoint.constant';
import { MYCPagination } from '../../components/table.component';
import { useForm } from 'antd/es/form/Form';
import { Constants, FILTER_TRIP_STATUSES, TripStatus, isRegionalManagerRole, getRegionalOriginIds } from '../../constants/general.constant';
import { useNavigate } from 'react-router-dom';
import { DefaultOrigins } from '../../constants/origins.constant';
import { UserContext } from '../../App';

const ACTIVE_STATUS_OPTIONS = FILTER_TRIP_STATUSES.filter(
    status => status.value !== TripStatus.Completed && status.value !== TripStatus.Cancelled
);
const HISTORY_STATUS_OPTIONS = FILTER_TRIP_STATUSES.filter(
    status => status.value === TripStatus.Completed || status.value === TripStatus.Cancelled
);

export const ActiveTripsScreen = ({history}) => {
    const { user } = useContext(UserContext);
    const isRegionalManager = isRegionalManagerRole(user);
    const isAdminUser = user?.role === Constants.ADMIN || user?.roles?.includes?.(Constants.ADMIN);
    const regionalOriginIds = useMemo(() => getRegionalOriginIds(user), [user]);
    const [query, setQueryParams] = useState({
        mode: history ? "history" : "active",
    });
    const [form] = useForm();

    const effectiveQuery = useMemo(() => ({
        ...query,
        ...(isRegionalManager && regionalOriginIds.length === 1 ? { originId: regionalOriginIds[0] } : {}),
    }), [query, isRegionalManager, regionalOriginIds]);
    const ordersRq = useGetPaginated(Endpoints.ALL_ORDERS,true,effectiveQuery);
    const originsRq = useGet(Endpoints.GET_ORIGINS);
    const origins = (Array.isArray(originsRq?.data) && originsRq.data.length > 0) ? originsRq.data : DefaultOrigins;
    const navigate = useNavigate();
    
    const _onSearch = values => {
        console.log("[SEARCH TRIP] value",values);
        if (values.date) {
            values.date = values.date?.$d?.toJSON?.() ?? undefined;
        }
        setQueryParams({
            ...query,
            ...values,
            mode: history ? "history" : "active",
        });
    }
    const onHistoryStatusChange = status => {
        setQueryParams(current => ({
            ...current,
            mode: "history",
            status,
        }));
    };
    const statusOptions = history ? HISTORY_STATUS_OPTIONS : ACTIVE_STATUS_OPTIONS;
    return <>
        <span className='self-center text-lg'>{history?"Trip Order History" : "Client Active Orders Terminal"}</span>
        <div className="self-center w-full my-5">
            <div className="flex flex-row gap-5  justify-between">
                <Form form={form} onFinish={_onSearch} layout="vertical">
                    <div className="flex items-end flex-row gap-5">
                        <MYCSearch name="clientRefNumber" className="flex-1" label="Search By Ref Number" />
                        {isAdminUser && <MYCSearch name="clientName" className="flex-1" label="Search By Client Name" />}
                        <MYCSelect name="status" className="flex-1" label="Search by Trip Status" options={statusOptions?.map((M) => ({label:M.label, value: M.value}))}/>
                        <MYCDate showTime={false} name="date"  label="Search Date" />
                        <Button htmlType="submit" className="px-5" type="primary">Search</Button>
                    </div>
                </Form>
                <Button onClick={() => navigate("/new-trip-order")} className="self-end px-10" type="primary">Create Trip Order</Button>
            </div>
            {history && <div className="mt-4 flex justify-end">
                <Segmented
                    value={query.status ?? "all"}
                    onChange={value => onHistoryStatusChange(value === "all" ? undefined : value)}
                    options={[
                        { label: "All", value: "all" },
                        { label: "Completed", value: TripStatus.Completed },
                        { label: "Cancelled", value: TripStatus.Cancelled },
                    ]}
                />
            </div>}
        </div>
        <div className="flex flex-col gap-5">
            {ordersRq?.list?.map?.(T => <TripOrderCard driver={T?.driver} key={T?.tripOrder.id.toString()} origins={origins} refresh={ordersRq?.refresh}  trip={T?.tripOrder} />)}
            <MYCPagination {...ordersRq}/>
        </div>


    </>
}
